import type { Margin } from '@/types/chart';

type Props = {
  width: number;
  height: number;
  chartMargins: Margin;
  onMouseMove: (event: React.MouseEvent<SVGRectElement, MouseEvent>) => void;
  onMouseLeave: () => void;
};

export const ReactiveArea = ({ width, height, chartMargins, onMouseMove, onMouseLeave }: Props) => (
  <rect
    width={width}
    height={Math.max(0, height - chartMargins.bottom)}
    className='cursor-crosshair'
    fill='transparent'
    aria-hidden
    onMouseMove={onMouseMove}
    onMouseLeave={onMouseLeave}
  />
);
